import React from 'react'
import { IoInformationCircle } from "react-icons/io5";
import { IoLogoModelS } from "react-icons/io";
// Import images
import sedanImage from "../img/car1.jpg";

import suvImage from "../img/car2.jpg";
import minivanImage from "../img/car3.jpg";
import fourByFourImage from "../img/car4.jpg";
import Carousel from '../components/Carousel';
function CarDetailsPage() {
   // Array of images with their labels and alt text
   const carouselItems = [
    { src: sedanImage, alt: "Sedan Car", label: "Sedan" },
    { src: suvImage, alt: "SUV Car", label: "SUV" },
    { src: minivanImage, alt: "Minivan Car", label: "Minivan" },
    { src: fourByFourImage, alt: "4x4 Car", label: "4x4" },
  ];
 

  
  return (
    <div className='bg-light'>
        <div className='container-fluid bg-white   mt-5 pt-5 '>
    <div className='container mt-5 mt-md-3   pb-md-3  pb-3 pt-5 '>
        <div className='d-flex justify-content-start align-items-center p-1'>
            <IoInformationCircle/> 
            <h6 className='fw-bold mx-2 my-auto'>Details</h6>
            <IoLogoModelS className='ms-4'/>
            <h6 className='fw-bold mx-2 my-auto'>Sedan</h6>
            <h6 className='fw-bold mx-2 my-auto'> Bmw i7</h6>
        </div>

        

    </div>

    </div>
    <div className='container mt-1  py-4'>
    <div className='row '>
            <div className='col-sm-12 col-md-7 rounded mx-auto my-3 p-3 '>
                <Carousel className=" bg-white  shadow" carouselItems={carouselItems}/>
                <div className='container d-flex flex-column rounded-top mt-5 p-0 bg-white'>
                    <div className='border-bottom bg-primary rounded-top p-3'>
                        <h6 className='text-start text-white fw-bold' style={{fontSize:"18px"}}>Car Details</h6>
                    </div>
                    <div className='mt-2 p-3'>
                        <h6 className='text-start text-secondary mb-2' style={{fontSize:"18px"}}>Transition type : Automatic</h6>
                        <h6 className='text-start text-secondary mb-2' style={{fontSize:"18px"}}>No. of cylinder: 4</h6>
                        <h6 className='text-start text-secondary mb-2' style={{fontSize:"18px"}}>Riding capacity : 5</h6>
                        <h6 className='text-start text-secondary mb-2' style={{fontSize:"18px"}}>With Air-conditioning</h6>
                        <h6 className='text-start text-secondary mb-2' style={{fontSize:"18px"}}>Body type : Sedan</h6>
                        <h6 className='text-start text-secondary mb-2' style={{fontSize:"18px"}}>Fuel type: petrol (Regular)</h6>
                        <button className='btn btn-outline-primary w-100 mt-3 fw-bold '>
                            Book Now
                        </button>

                    </div>

                </div>
            </div>
            <div className='col-sm-12 col-md-4   mx-auto py-0 align-content-start my-3  '>
                <div >
                <div className=' shadow bg-white rounded p-0 d-flex mb-3  flex-column w-100 '>
                    <div className="p-3 border-bottom flex justify-content-start bg-primary rounded-top  pb-1">
                        <h6 className='fw-bold text-start align-items-center text-white'>Similar cars <IoLogoModelS size={30}/></h6>
                    </div>
                    <div className='container-fluid   p-0'>
                        <div className='d-flex p-3 border-bottom'>
                        <div className='col-5  p-1 '>
                            <img src={sedanImage} alt='' className='w-100 rounded' style={{objectFit:"contain", height:"120px"}}/>
                        </div>
                        <div className='col-7 p-2 d-flex flex-column'>
                            <h6 className='fw-bold text-start mb-3'>Suzuki Dzire</h6>
                            <h6 className='small text-secondary text-start '>Transition type : Automatic </h6>
                            <h6 className='small text-secondary text-start '>Riding capacity : 5 </h6>
                            <h6 className='small text-secondary text-start '>No. of cylinder: 4 </h6>

                        </div>
                        </div>
                    </div>

                </div>
                <div className=' shadow bg-white rounded p-0 d-flex mb-3 flex-column w-100'>
                    <div className="p-3 border-bottom flex justify-content-start bg-primary rounded-top  pb-1">
                        <h6 className='fw-bold text-start align-items-center text-white me-3'>Car Types <IoLogoModelS size={30}/></h6>
                    </div>
                    <div className='container-fluid    p-0'>
                        <div className='d-flex justify-content-between p-3 border-bottom flex-wrap'>
                        <span className='btn btn-outline-secondary mb-2 fw-bold'> Luxury</span>
                        <span className='btn btn-outline-secondary mb-2 fw-bold'> Compact SUV</span>
                        <span className='btn btn-outline-secondary mb-2 fw-bold'> full_size_suv</span>
                        <span className='btn btn-outline-secondary mb-2 fw-bold'> Minivan</span>
                        <span className='btn btn-outline-secondary mb-2 fw-bold'> electric</span>
                        <span className='btn btn-outline-secondary mb-2 fw-bold'> compact</span>
                        </div>
                    </div>

                </div>
                </div>
              
            </div>
        </div>
    </div>

    </div>
    
  )
}

export default CarDetailsPage